window.addEventListener("DOMContentLoaded", function () {
 
  initProductFloatAddCart();

  function initProductFloatAddCart() {
    if (!customElements.get("product-float-add-cart")) {
      customElements.define(
        "product-float-add-cart",
        class ProductFloatAddCart extends HTMLElement {
          abortController = undefined;
          constructor() {
            super();
            this.position = this.getAttribute("data-position");
            this.pfac_mask = this.querySelector(".pfac_mask");
            this.pfac_float_btn = this.querySelector(".pfac_float_btn");
            this.pfac_content = this.querySelector(".pfac_content");
            this.pfac_close_btn = this.querySelector(".pfac_content_close");
            this.sectionId = $(this)
              .parent("product-info")
              .attr("data-section");
            this.productUrl = $(this).parent("product-info").attr("data-url");

            this.autoPlayTimer = null;

            


            
            

            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            

            

            this.closeTimer = null;
            this.pfacSwiper = null;
            
          }

          connectedCallback() {
            const that = this;

            
            this.initScrollListener();
            this.initState();
            this.initContentPadding();
            this.initPopListener();
            this.initPopQuantity();
            this.initPopVariant();
            this.initBuyButtons();
            this.initPreviewImg();

            this.initTitleSwiper();


            // 订阅变量变化监听
            subscribe(PUB_SUB_EVENTS.variantChange,function({data}){
              console.log("变量变化....",data)

              
              console.log($('.product__info-container > variant-selects').find("input[type='radio']:checked"))
          
              
              let option_values = Array.from($('.product__info-container > variant-selects').find("input[type='radio']:checked")).map(item => {
                
                return $(item).attr('data-option-value-id');
              })

              function unique(arr) {
                const result = [];
                let hasNaN = false;
                for (const item of arr) {
                  if (item !== item) { // 检测 NaN
                    if (!hasNaN) {
                      result.push(item);
                      hasNaN = true;
                    }
                  } else {
                    let isDuplicate = false;
                    for (const res of result) {
                      if (item === res) {
                        isDuplicate = true;
                        break;
                      }
                    }
                    if (!isDuplicate) result.push(item);
                  }
                }
                return result;
              }

              that.renderPopContent(unique(option_values).join(','));
            })
          }

          initPreviewImg(){
            const that = this;
            $(this).find('.pafc_preview_img').on('click',function(e){
              e.stopPropagation();
              $(that).find('.pafc_preview_img').hide();
            })

            $(this).find('.pafc_preview_img img').on('click',function(e){
              e.stopPropagation();
            })

            $(this).find('.pfac_content_info_img').on('click',function(e){
              $(that).find('.pafc_preview_img').css("display","flex");
            })
            
          }
          

          initBuyButtons() {
            const that = this;
            // 事件代理
            $(that.pfac_content).on(
              "click",
              ".pfac_add_to_cart",
              function (e) {
                e.stopPropagation();
                let num = $(that).find('.pfac_quantity .pfac_num').text().trim();
                let id = $(that).find('.pfac_variant_pickers').attr('data-prod-id').trim();

                console.log("......add cart....")

                let data = {
                  'id':id,
                  'quantity':parseInt(num)
                }


                if (that.cart) {
                  data['sections'] = that.cart.getSectionsToRender().map((section) => section.id);
                }

                $.ajax({
                    type: 'POST',
                    url: "/cart/add.js",
                    data: data,
                    success: function(res){
                      console.log(res,'---12312--')
                      
                      if (!(that.cart)) {
                        console.log("加购.....1......")
                        window.location = window.routes.cart_url;
                        that.closePop();
                        
                      }else{
                        that.closePop();
                        that.cart.renderContents(res);
                        if (that.cart && that.cart.classList.contains('is-empty')) that.cart.classList.remove('is-empty');
                      }
                    },
                    dataType: 'json'
                });

                
              }
            );
            // 事件代理
            $(that.pfac_content).on("click", ".pfac_buy_now", function (e) {
              e.stopPropagation();
              let num = $(that).find('.pfac_quantity .pfac_num').text().trim();
              let id = $(that).find('.pfac_variant_pickers').attr('data-prod-id').trim();
              window.location.href=`/cart/${id}:${num}`;
              that.closePop();
            });
          }

          initTitleSwiper() {
            const that = this;
            if (
              Array.from($(this).find(".pfac_content_title_text")).length >= 1
            ) {
              that.pfacSwiper = new Swiper(".pfac_swiper", {
                direction: "vertical",
                loop: true,
                autoplay: {
                  disableOnInteraction: false,
                  delay: 2500,
                }
              });
            }
          }

          initPopVariant() {
            const that = this;

            $(that.pfac_content).off("click", ".pfac_variant_item");

            $(that.pfac_content).on("click", ".pfac_variant_item", function () {
              if ($(this).hasClass("disabled")) {
                return false;
              }

              $(this)
                .addClass("pfac_active_variant")
                .siblings()
                .removeClass("pfac_active_variant");

              that.handleVariantChange();
            });
          }

          handleVariantChange() {
            const that = this;
            let option_values = [];
            let _activeVariant = $(that).find(".pfac_active_variant");
            Array.from(_activeVariant).forEach((item) => {
              option_values.push($(item).attr("data-option-value-id"));
            });

            that.renderPopContent(option_values.join(","));

            $(that).find(".pfac_buttons").addClass("disabled");
          }

          renderPopContent(option_values) {
            const that = this;
            this.abortController?.abort();
            this.abortController = new AbortController();
            let requestUrl = `${that.productUrl}?section_id=${that.sectionId}&option_values=${option_values}`;
            fetch(requestUrl, { signal: this.abortController.signal })
              .then((response) => response.text())
              .then((responseText) => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(
                  responseText,
                  "text/html"
                );

                that.updateNode(html);
              })
              .catch((error) => {
                if (error.name === "AbortError") {
                  console.log("Fetch aborted by user");
                } else {
                  console.error(error);
                }
              });
          }

          updateNode(newHtml) {
            const that = this;
            const oldRoot = this;
            const newRoot = newHtml;

            // 使用 DocumentFragment 减少重绘次数
            const fragment = document.createDocumentFragment();

            // 预先查询所有父元素，避免重复查询
            const parentElements = {
              ".pfac_content_info_img": oldRoot.querySelector(
                ".pfac_content_info_img"
              ),
              ".pfac_content_info_view_right": oldRoot.querySelector(
                ".pfac_content_info_view_right"
              ),
              ".pfac_footer": oldRoot.querySelector(".pfac_footer"),
              ".pfac_center_content": oldRoot.querySelector(".pfac_center_content"),
              ".pafc_preview_img": oldRoot.querySelector(".pafc_preview_img")
              
            };

            // 收集所有需要更新的元素
            const updateQueue = [];

            // 批量替换元素
            [
              {
                selector: ".fpac_big_pro_img",
                parent: ".pafc_preview_img"
              },
              {
                selector: ".fpac_small_pro_img",
                parent: ".pfac_content_info_img",
              },
              {
                selector: ".pfac_prices",
                parent: ".pfac_content_info_view_right",
              },
              {
                selector: ".pfac_variant_pickers",
                parent: ".pfac_center_content",
              },
              {
                selector: ".pfac_buttons",
                parent: ".pfac_footer",
              }
            ].forEach(({ selector, parent }) => {
              const oldEl = oldRoot.querySelector(selector);
              const newEl = newRoot.querySelector(selector);
              const parentEl = parentElements[parent];



              if (oldEl && newEl && parentEl) {
                // 将更新操作添加到队列中，而不是立即执行
                updateQueue.push(() => {
                  parentEl.replaceChild(_cloneWithState(newEl, oldEl), oldEl);
                });
              }
            });

            // 使用 requestAnimationFrame 批量处理 DOM 更新
            if (updateQueue.length > 0) {
              requestAnimationFrame(() => {
                // 执行所有更新操作
                updateQueue.forEach((update) => update());
                // 所有 DOM 更新完成后再绑定事件
                _bindDynamicEvents(oldRoot);
              });
            } else {
              // 如果没有更新，直接绑定事件
              _bindDynamicEvents(oldRoot);
            }

            

            // 克隆节点并保留状态 (私有方法)
            function _cloneWithState(newEl, oldEl) {
              // 使用高效的克隆方式
              const cloned = newEl.cloneNode(true);

              // 保留样式、类名、尺寸
              // cloned.className = oldEl.className;
              cloned.style.cssText = oldEl.style.cssText;
              

              if (cloned.tagName === "IMG") {
                // 预加载图片以避免闪烁
                if (cloned.src !== oldEl.src) {
                  const img = new Image();
                  img.onload = () => {
                    cloned.width = oldEl.width || img.width;
                    cloned.height = oldEl.height || img.height;
                  };
                  img.src = cloned.src;
                } else {
                  cloned.width = oldEl.width;
                  cloned.height = oldEl.height;
                }
              }

              // 保留滚动位置
              if (oldEl.scrollHeight > oldEl.clientHeight) {
                const scrollTop = oldEl.scrollTop;
                requestAnimationFrame(() => (cloned.scrollTop = scrollTop));
              }

              return cloned;
            }

            // 事件绑定 (私有方法)
            function _bindDynamicEvents(root) {
              that.initPopVariant();
            }
          }

          // 初始化步进器
          initPopQuantity() {
            const that = this;
            $(that.pfac_content).off("click", ".pfac_quantity_btn");
            $(that.pfac_content).on("click", ".pfac_quantity_btn", function () {
              if ($(this).hasClass("disabled")) {
                return false;
              }
              let _num = parseInt($(this).siblings(".pfac_num").text().trim());
              let _type = $(this).attr("data-type");
              if (_type == "minus") {
                if (_num > 1) {
                  _num = --_num;
                  $(this).siblings(".pfac_num").text(_num);

                  if (_num == 1) {
                    $(this).addClass("disabled");
                  } else {
                    $(this).removeClass("disabled");
                  }
                } else {
                  return false;
                }
              } else {
                _num = ++_num;
                $(this).siblings(".pfac_num").text(_num);
                $(this).siblings(".pfac_minus").removeClass("disabled");
              }
            });
          }

          closePop(){
            const that = this;
            $(that.pfac_content)
              .removeClass("animate__fadeInUp animate__fadeOutDown")
              .addClass("animate__fadeOutDown");
            clearTimeout(that.closeTimer);
            that.closeTimer = setTimeout(function () {
              $(that.pfac_mask).fadeOut();
            });
          }

          initPopListener() {
            const that = this;
            // 阻止冒泡
            $(this)
              .find(".pfac_content")
              .on("click", function (e) {
                e.stopPropagation();
              });

           

            // 关闭弹窗事件
            $(".pfac_mask").on("click", function () {
              that.closePop();
            });

            $(that.pfac_content).off("click", ".pfac_content_close");
            $(that.pfac_content).on(
              "click",
              ".pfac_content_close",
              function () {
                that.closePop();
              }
            );

            // 弹窗展示
            $(".pfac_float_btn").on("click", function () {
              
              $(that.pfac_mask).fadeIn();
              that.initContentPadding();
              $(that.pfac_content)
                .removeClass("animate__fadeInUp animate__fadeOutDown")
                .addClass("animate__fadeInUp");

              // 显示后需要重新触发一下swiper自动轮播
              if ((that.pfacSwiper)) {
                if((that.autoPlayTimer)){
                  clearTimeout(that.autoPlayTimer);
                  that.autoPlayTimer = null;
                }
                

                console.log(that.pfacSwiper.autoplay.running)
                that.autoPlayTimer = setTimeout(function(){

                  that.pfacSwiper.autoplay.stop();
                  console.log("autoplay::::start.....执行......")
                    that.pfacSwiper.autoplay.start();
                },3000)
             
              }
            });
          }

          initContentPadding() {
            // let pfac_footer = this.querySelector(".pfac_footer");


            // $(this)
            //   .find(".pfac_center_content")
            //   .css("paddingBottom", `${pfac_footer.offsetHeight + 10}px`);
          }

          initState() {
            const element = document.querySelector(
              ".pfac_visable"
            );
            const rect = element.getBoundingClientRect();
            const bottomToViewportTop = rect.bottom;
            if (bottomToViewportTop < 0) {
              this.showFloatAddCart();
            }
          }

          initScrollListener() {
            const that = this;
            const targetElement = document.querySelector(
              ".pfac_visable"
            );
            let lastScrollY = window.scrollY; // 记录上次滚动位置
            let isScrollingDown = false; // 当前滚动方向

            // 1. 监听滚动方向
            window.addEventListener("scroll", () => {
              const currentScrollY = window.scrollY;
              isScrollingDown = currentScrollY > lastScrollY;
              lastScrollY = currentScrollY;
            });

            // 2. 创建观察器，结合滚动方向判断
            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (isScrollingDown && !entry.isIntersecting) {
                    // 向下滚动，元素离开视窗
                    console.log("向下滚动，元素消失");
                    that.showFloatAddCart();
                  } else if (!isScrollingDown && entry.isIntersecting) {
                    // 向上滚动，元素进入视窗
                    console.log("向上滚动，元素出现");

                    that.hideFloatAddCart();
                  }
                });
              },
              { threshold: 0 }
            ); // threshold: 0 确保任何可见性变化都触发

            // 3. 开始观察元素
            observer.observe(targetElement);
          }

          hideFloatAddCart() {
            if (this.position == "top") {
              $(".pfac_float_btn_content")
                .removeClass(
                  "animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp"
                )
                .addClass("animate__fadeOutUp");
            } else {
              $(".pfac_float_btn_content")
                .removeClass(
                  "animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp"
                )
                .addClass("animate__fadeOutDown");
            }
          }

          showFloatAddCart() {
            if (this.position == "top") {
              const element = document.querySelector(".section-header");
              const rect = element.getBoundingClientRect();
              const bottomToViewportTop = rect.bottom;
              if (bottomToViewportTop > 0) {
                $(".pfac_float_btn_content").css(
                  "top",
                  `${bottomToViewportTop}px`
                );
              } else {
                $(".pfac_float_btn_content").css("top", "0");
              }
              $(".pfac_float_btn_content")
                .removeClass(
                  "animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp"
                )
                .addClass("animate__fadeInDown");
            } else {
              $(".pfac_float_btn_content").css("bottom", "0");
              $(".pfac_float_btn_content")
                .removeClass(
                  "animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp"
                )
                .addClass("animate__fadeInUp");
            }
          }
        }
      );
    }
  }
});
